export enum userStatus {
  Online = 1,
  Ausente = 2,
  Ocupado = 3,
  Invisivel = 4,
}
